import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "components/Button";
import { getConsignmentById } from "selectors";

import { EMPTY_OBJECT } from "lib";
import { ConsignmentAction } from "actions";
import { NeverEverIntegrationStatus } from "components/NeverEver/NeverEverIntegration";

export interface ConsignmentNeverEverEligibilityProps {
  consignmentId: string;
}

export function ConsignmentNeverEverEligibility(
  props: ConsignmentNeverEverEligibilityProps,
): React.JSX.Element {
  const { consignmentId } = props;

  const consignment =
    useSelector(getConsignmentById(consignmentId)) || EMPTY_OBJECT;

  const { syncing: consignmentSyncing, vendor_property_id: vendorPropertyId } =
    consignment;

  // Syncing could also be undefined, so check carefully!
  const enabled = consignmentSyncing !== true && Boolean(vendorPropertyId);

  const dispatch = useDispatch();

  function handleOnClick(): void {
    dispatch(ConsignmentAction.checkNeeAccreditation(consignmentId));
  }

  return (
    <>
      <hr />
      <Grid container spacing={4}>
        <Grid item xs={7} alignItems="center" container>
          <NeverEverIntegrationStatus
            consignmentId={consignmentId}
            showNoRequests
            showTextStatus
          />
        </Grid>
        <Grid item xs={5}>
          <Button
            disabled={!enabled}
            fullWidth
            onClick={handleOnClick}
            title={
              enabled
                ? ""
                : "Consignments must have a Vendor PIC assigned to check NEE status."
            }
            type="button"
          >
            Request NEE accreditation
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
